//작성중인 패키지 리스트 확인하는 페이지
import { useEffect, useState } from 'react'
import {
  FormattedMessage,
  FormattedHTMLMessage,
  defineMessages,
  useIntl,
} from 'react-intl'
import { Button, Modal, Table, Icon, Layout, Divider, Spin } from 'antd'
import moment from 'moment'

import PkgStatus from '../../components/PkgStatus'
import Headline from '../../components/Headline'

import { PackageInfo, PackType } from '../../types'
import { ColumnProps } from 'antd/es/table'
import MypageNav from '../../components/navigation/MypageNav'
import { useGetMyPackage } from '../../hooks/reactQuery/useUserInfo'
import { useUserWithRedirect } from '../../hooks/user/useUserWithRedirect'
import PackageWrapperWithStatus from '../package/PackageWrapperWithStatus'
import dayjs from 'dayjs'
import rootHistory from '../../rootHistory'
const returnDateFormat = (date: any) =>
  date === undefined ? date : moment(date).format('YYYY.MM.DD')

const messages = defineMessages({
  thumbnail: {
    id: 'ReviewedPkgList.table.thumbnail',
    defaultMessage: 'Thumbnail',
  },
  pkgName: {
    id: 'ReviewedPkgList.table.packTypeName',
    defaultMessage: 'Pack name',
  },
  reviewRequestedAt: {
    id: 'ReviewedPkgList.table.reviewRequestedAt',
    defaultMessage: 'Date\nsubmitted',
  },
  approvedAt: {
    id: 'ReviewedPkgList.table.approvedAt',
    defaultMessage: 'Date\napproved',
  },
  status: {
    id: 'ReviewedPkgList.table.status',
    defaultMessage: 'Approval status',
  },
})

export default function ReviewedPkgList() {
  const intl = useIntl()

  const user = useUserWithRedirect()

  const { data: packageList, isLoading } = useGetMyPackage({
    userOid: user?.objectId,
    sessionToken: user?.sessionToken,
  })

  const reviewedPackageList = packageList?.filter((pkg) => {
    if (
      pkg.status === 'pre deleted' ||
      pkg.status === 'unapproved' ||
      pkg.status === 'under review'
    ) {
      return true
      //todo approved 인 패키지 불러오기 기능
      // }else if( pkg.status === 'approved'){
      //   if(pkg.){

      //   }
    } else if (pkg.status === 'approved') {
      const approvedAt = pkg.packageInspectionData?.approvedAt
      if (approvedAt) {
        const approvedDate = dayjs(new Date(approvedAt))
        const currentDate = dayjs(new Date())
        if (currentDate.diff(approvedDate, 'd') < 15) {
          return true
        }
        return false
      }
    }
    return false
  })
  const [packageId, setPackageId] = useState<null | string>(null)
  const columns: ColumnProps<PackageInfo>[] = [
    {
      title: intl.formatMessage(messages.thumbnail),
      dataIndex: 'thumbnail',
      width: 114,
      align: 'center',
      className: 'reviewed-pkg-list-column',
      render: ({ url }, rec) => {
        return (
          <img
            src={url}
            style={{
              width: 60,
              borderRadius: 5,
              border: 'solid 1px #979797',
            }}
            alt="thumbnail"
          />
        )
      },
    },
    {
      title: intl.formatMessage(messages.pkgName),
      dataIndex: 'packType',
      align: 'center',
      width: 200,
      render: (packType: PackType, record: PackageInfo) => (
        <div style={{ textAlign: 'start' }}>
          {packType && (
            <span
              className={`pack-type-badge-${packType}`}
              style={{ display: 'flex', margin: 0 }}
            >
              <FormattedMessage
                id={`ReviewedPkgList.table.packType.${packType}`}
              />
            </span>
          )}
          <p
            style={{
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              marginBottom: 0,
              width: 180,
            }}
          >
            {record.name.en}
          </p>
        </div>
      ),
    },
    {
      title: intl.formatMessage(messages.reviewRequestedAt),
      dataIndex: 'packageInspectionData.reviewRequestedAt',
      align: 'left',
      width: 90,
      sorter: (a, b) => {
        if (
          a.packageInspectionData?.reviewRequestedAt &&
          b.packageInspectionData?.reviewRequestedAt
        ) {
          return (
            new Date(a.packageInspectionData.reviewRequestedAt).valueOf() -
            new Date(b.packageInspectionData.reviewRequestedAt).valueOf()
          )
        }
        return 1
      },
      className: 'reviewed-pkg-list-column',
      render: (reviewRequestedAt) => {
        return returnDateFormat(reviewRequestedAt)
      },
    },
    {
      title: intl.formatMessage(messages.approvedAt),
      dataIndex: 'packageInspectionData.approvedAt',
      align: 'left',
      width: 90,
      className: 'reviewed-pkg-list-column',
      sorter: (a, b) => {
        if (
          a.packageInspectionData &&
          b.packageInspectionData &&
          a.packageInspectionData.reviewRequestedAt &&
          b.packageInspectionData.reviewRequestedAt &&
          a.packageInspectionData.approvedAt &&
          b.packageInspectionData.approvedAt
        ) {
          return a.packageInspectionData.approvedAt.valueOf() &&
            b.packageInspectionData.approvedAt.valueOf()
            ? new Date(a.packageInspectionData.reviewRequestedAt).valueOf() -
                new Date(b.packageInspectionData.reviewRequestedAt).valueOf()
            : new Date(a.packageInspectionData.reviewRequestedAt).valueOf()
            ? 1
            : -1
        }
        return 1
      },
      render: (approvedAt) =>
        approvedAt ? returnDateFormat(approvedAt) : null,
    },
    {
      title: intl.formatMessage(messages.status),
      dataIndex: 'status',
      align: 'left',
      className: 'reviewed-pkg-list-column',
      render: (status, record, idx) =>
        status === 'unapproved' ||
        status === 'editing' ||
        status === 'pre deleted' ? (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <PkgStatus status={status} />
          </div>
        ) : (
          <PkgStatus status={status} />
        ),
      filters: [
        {
          text: (
            <FormattedMessage
              id="PkgStatus.underReview"
              defaultMessage="Pending"
            />
          ),
          value: 'under review',
        },
        {
          text: (
            <FormattedMessage
              id="PkgStatus.unapproved"
              defaultMessage="Rejected"
            />
          ),
          value: 'unapproved',
        },
        {
          text: (
            <FormattedMessage
              id="PkgStatus.approved"
              defaultMessage="Approved"
            />
          ),
          value: 'approved',
        },
      ],
      onFilter: (value, record) =>
        value === 'unapproved'
          ? record.status.indexOf(value) === 0 ||
            record.status === 'pre deleted'
          : record.status.indexOf(value) === 0,
      filterIcon: <Icon type="filter" theme="filled" />,
      defaultSortOrder: 'descend',
    },
    {
      dataIndex: 'status2',
      render: (status, record, idx) =>
        record.status === 'unapproved' || record.status === 'pre deleted' ? (
          <Button
            type="primary"
            ghost
            style={{
              borderRadius: 5,
              margin: 0,
              padding: '5px 10px',
              height: 30,
              border: '1px solid #a202ff',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
            className="unapproved-pkg-btn"
            onClick={() => {
              setPackageId(record.objectId)
            }}
          >
            <FormattedMessage
              id={'ReviewedPkgList.btn.unapproved'}
              defaultMessage={'Why?🤔'}
            />
          </Button>
        ) : null,
    },
  ]
  return (
    <Layout style={{ height: 'inherit' }}>
      <MypageNav selectedKey={'packages-of-reviewed'} />
      <Layout.Content style={{ margin: 20 }}>
        <Headline
          id="ReviewedPkgList.headline"
          defaultMessage="Approval Status"
          styles={{
            margin: '22px 0px 24px 0px',
            fontFamily: 'NotoSans',
            fontSize: '34px',
            lineHeight: '36px',
            letterSpacing: 0,
          }}
        />
        <div style={{ margin: '0px 25px 30px 25px' }}>
          <div
            style={{
              fontSize: 16,
              color: '#000',
              letterSpacing: -0.42,
              lineHeight: 1.5,
            }}
          >
            <FormattedMessage
              id={'ReviewedPkgList.guide.title'}
              defaultMessage={
                'You may check the approval status of packs that have been submitted for review.'
              }
            />
          </div>
          <div
            style={{
              fontSize: 14,
              color: '#828282',
              lineHeight: 1.64,
              letterSpacing: -0.4,
              marginTop: 10,
            }}
            className="reviewed-pkg-list-explain"
          >
            <FormattedHTMLMessage
              id={'ReviewedPkgList.guide.description'}
              defaultMessage={
                'You can check rejection details by clicking Why? button of the pack.<br>Approved packs may be immediately released for use and automatically deleted from this page after 15 days.'
              }
            />
          </div>
        </div>
        <div style={{ margin: '0px 25px 77px 25px' }}>
          <Spin spinning={!packageList} tip="Loading...">
            <Table
              columns={columns}
              dataSource={reviewedPackageList as PackageInfo[]}
              locale={{
                filterConfirm: 'OK',
                filterReset: 'Reset',
                emptyText: 'No Data',
              }}
              pagination={false}
              rowKey="objectId"
              // loading={loading}
              className="reviewed-pkg-table"
            />
          </Spin>
        </div>
        <Modal
          visible={packageId ? true : false}
          onOk={() => setPackageId(null)}
          onCancel={() => setPackageId(null)}
          footer={null}
          width={862}
          className="progress-guide-modal"
          bodyStyle={{
            padding: '16px  64px',
            lineHeight: 1.79,
            letterSpacing: -0.36,
            color: '#828282',
            fontSize: 14,
          }}
        >
          {packageId && <PackageWrapperWithStatus packageId={packageId} />}
        </Modal>
      </Layout.Content>
    </Layout>
  )
}
